import React from "react";
import { useNavigate } from "react-router-dom";
import { IconMov } from "../../components/icons-anim/Icon";
import { TextChange } from "../../components/text-change/Textchange";
import { MainTitle } from "../../components/main-title/MainTitle";
import { Link } from "react-router-dom";
import './terms.css';

function Terms() {
  const navigate = useNavigate();
  return (
    <div>
      {/** Nav Menu */}
      <div class="nav-menu fixed-top">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <nav class="navbar navbar-dark navbar-expand-lg">
                <Link class="navbar-brand" to="/">
                  <img src="images/logo.png" class="img-fluid" alt="logo" />
                </Link>
              </nav>
            </div>
          </div>
        </div>
      </div>
      <header class="bg-gradient" id="home"></header>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div style={{marginBottom:'20px'}}>
            <button
              class="navbar-toggler icon-bu"
              type="button"
              data-toggle="collapse"
              data-target="#navbar"
              aria-controls="navbar"
              aria-expanded="false"
              aria-label="Toggle navigation"
              onClick={() => navigate(-1)}
            >
              <span class="ti-arrow-left ti-2x mr-2"></span>
            </button>
          </div>
          <div>
            <h1>Terms and Conditions</h1>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            alignContent: "center",
          }}
        >
          <div>
            <p>here we will say</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Terms;
